import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { Store } from '@ngrx/store';
import {
  ActividadGrupoEspecie,
  CheckItem,
  CheckListFormComponent,
  CheckListFormInput,
  createActividadGrupoEspecie,
  createEmptyCheckListFormInput
} from '@rpe/registro-personas-empresas-lib';

import { ROUTE_ANIMATIONS_ELEMENTS } from '../../../../core/core.module';
import { entityActividadesGrupoEspecieAddRequest } from '../../entity-actividades-grupo-especie/entity-actividades-grupo-especie.actions';
import { State } from '../../../vista-usuario/vista-usuario.state';
import { GrupoEspecieFormInput } from '../../entity-grupos-especie/grupo-especie.model';

@Component({
  selector: 'rpe-registro-actividad-ge-form',
  templateUrl: './registro-actividad-ge-form.component.html',
  styleUrls: ['./registro-actividad-ge-form.component.scss']
})
export class RegistroActividadGrupoEspecieFormComponent implements OnInit {
  @Input()
  set formInput(auxFormInput: GrupoEspecieFormInput) {
    this._formInput = auxFormInput;
    this.formInputCheckList = createEmptyCheckListFormInput();
    this.formInputCheckList.elementosCheck = auxFormInput.listaCheckItem;
  }
  get formInput(): GrupoEspecieFormInput {
    return this._formInput;
  }

  @Output() showEvent: EventEmitter<boolean> = new EventEmitter<boolean>(true);

  // CheckList
  @ViewChild(CheckListFormComponent, { static: true })
  checkListForm: CheckListFormComponent;

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;

  _formInput: GrupoEspecieFormInput = null;
  formInputCheckList: CheckListFormInput = null;

  formStatus: string = 'INVALID';
  actividadesGrupoEspecie: ActividadGrupoEspecie[] = [];

  constructor(private store: Store<State>) {}

  ngOnInit(): void {}

  onCancel() {
    this.showEvent.emit(false);
  }

  onGuardar() {
    if (this.formStatus == 'VALID') {
      this.store.dispatch(
        entityActividadesGrupoEspecieAddRequest({
          item: this.actividadesGrupoEspecie
        })
      );
    } else {
      this.checkListForm.onShowErrors();
    }
  }

  formValueChanges(cl: CheckItem[]) {
    this.actividadesGrupoEspecie = [];
    cl.forEach((c) =>
      this.actividadesGrupoEspecie.push(
        createActividadGrupoEspecie({
          id: c.id,
          //actividad_id: this._formInput.actividadId,
          grupo_especie_id: c.tipo_id
        })
      )
    );
  }

  formStatusChanges(status: string) {
    this.formStatus = status;
  }
}
